module.exports = __webpack_public_path__ + "img/463F37_ACCFBB_818B78_91A494-256px.2423eddb.png";